// extracted by mini-css-extract-plugin
export default {"projectCard":"_1c5u_dKw","projectInfo":"_3LrdzBHO","projectTitle":"F4_XpDff","projectButtons":"_1lJQ-ZW3","button":"oxc_9Bkw","desktop":"_1unpp8dK","mobile":"_22gemCaf"};